<template>
  <el-dialog :visible.sync="isShow"
             @close='closeHandler'
             @open='openHandler'
             custom-class="common_tips_dialog_wrap"
             :close-on-click-modal="false"
             :width="dw">
    <div id="common_tips_dialog">
      <div class="img">
        <img :src="warning" alt="">
      </div>
      <div class="tips">
        <p v-html="tips"></p>
      </div>
      <div class="btns">
        <el-button class="button"
                   type="primary"
                   :loading="loading"
                   :disabled="isBtnDisabled"
                   @click="doSubmit">确定
        </el-button>
        <el-button class="button"
                   type="danger"
                   @click="doCancel">取消
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import warning from "@/assets/images/warning.png";
  export default {
    name: "Dialog",
    props: {
      tips: {
        type: String,
        default: "确定嘿嘿嘿嘛？",
      },
      showTips: {
        type: Boolean,
        required: true,
        default: false,
      },
      dw: {
        type: String,
        default: "440px"
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        warning,
        isBtnDisabled: false,
      }
    },
    computed: {
      isShow: {
        get(){
          return this.showTips;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击确定按钮
          this.$emit("hideTips", bool, false);
        }
      },
    },
    methods: {
      doSubmit() {
        this.$emit("hideTips", false, true);
      },
      doCancel() {
        this.isShow = false;
      },
      closeHandler() {
        this.isBtnDisabled = true;
      },
      openHandler() {
        this.isBtnDisabled = false;
      }
    }
  }
</script>
<style lang="stylus">
  .common_tips_dialog_wrap {
    margin-top: 25vh !important;
    /*.el-dialog__header {
      padding: 0;
    }*/
  }
</style>
<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  #common_tips_dialog {
    width: 100%;
    user-select: none;
    .img {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tips {
      width: 100%;
      margin: 15px 0 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_big;
      p {
        width: 100%;
        text-align: center;
        word-break: break-all;
      }
    }
    .btns {
      margin: 0 0 15px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $color_white;
      .btn {
        margin: 0 25px;
        padding: 5px 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        cursor: pointer;
      }
      .sure {
        background-color: $color_suc;
        box-shadow: 0 2px 10px $color_suc;
      }
      .cancel {
        background-color: $color_err;
        box-shadow: 0 2px 10px $color_err;
      }
      .el-button--danger {
        background-color $color_err 
      }
      .button + .button {
        margin-left 30px;
      }
    }
  }
</style>